<div class="card m-6">
    <div class="flex justify-between items-center mb-4">
        <h2 class="text-2xl font-bold">Veículos</h2>
        <p-button 
            label="Adicionar" 
            icon="pi pi-plus" 
            (onClick)="navigateToCreate()" 
            severity="success" />
    </div>

    <!-- Filtros -->
    <div class="mb-4 p-4 bg-gray-50 rounded-lg">
        <div class="flex justify-between items-center mb-3">
            <h3 class="text-lg font-semibold">Filtros</h3>
            <p-button 
                label="Limpar Filtros" 
                icon="pi pi-filter-slash" 
                severity="secondary"
                size="small"
                (onClick)="clearFilters()" />
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <!-- Campo de Busca -->
            <div>
                <label for="searchInput" class="block text-sm font-medium mb-2">Buscar</label>
                <input 
                    type="text" 
                    pInputText 
                    id="searchInput"
                    [(ngModel)]="searchTerm" 
                    placeholder="Pesquisar veículos..." 
                    class="w-full"
                    (input)="onSearchChange(searchTerm)" />
            </div>

            <!-- Filtro por Motorista -->
            <div>
                <label for="driverFilter" class="block text-sm font-medium mb-2">Motorista</label>
                <p-select 
                    id="driverFilter"
                    [(ngModel)]="driverId"
                    [options]="drivers"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Selecione um motorista"
                    [showClear]="true"
                    (onChange)="onDriverChange($event.value)"
                    class="w-full" />
            </div>

            <!-- Filtro por Status -->
            <div>
                <label for="statusFilter" class="block text-sm font-medium mb-2">Status</label>
                <p-select 
                    id="statusFilter"
                    [(ngModel)]="active"
                    [options]="[
                        { label: 'Ativo', value: true },
                        { label: 'Inativo', value: false }
                    ]"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione o status"
                    [showClear]="true"
                    (onChange)="onActiveChange($event.value)"
                    class="w-full" />
            </div>
        </div>
    </div>

    <p-table 
        [value]="vehicles" 
        [paginator]="true" 
        [rows]="10" 
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} veículos"
        [tableStyle]="{'min-width': '50rem'}"
        styleClass="p-datatable-striped">
        
        <ng-template #header>
            <tr>
                <th style="width:8%">ID</th>
                <th style="width:15%">Modelo</th>
                <th style="width:15%">Marca</th>
                <th style="width:12%">Placa</th>
                <th style="width:10%">Assentos</th>
                <th style="width:10%">Status</th>
                <th style="width:15%">Ações</th>
            </tr>
        </ng-template>
        
        <ng-template #body let-vehicle>
            <tr>
                <td>{{ vehicle.id }}</td>
                <td>{{ vehicle.model }}</td>
                <td>{{ vehicle.brand }}</td>
                <td>{{ vehicle.licensePlate }}</td>
                <td>{{ vehicle.seatCount }}</td>
                <td>
                    <p-tag 
                        [value]="vehicle.active ? 'Ativo' : 'Inativo'" 
                        [severity]="vehicle.active ? 'success' : 'danger'" />
                </td>
                <td>
                    <div class="flex gap-2">
                        <p-button 
                            icon="pi pi-pencil" 
                            severity="info" 
                            size="small"
                            (onClick)="editVehicle(vehicle.id)"
                            pTooltip="Editar" />
                        <p-button 
                            icon="pi pi-trash" 
                            severity="danger" 
                            size="small"
                            (onClick)="deleteVehicle(vehicle.id)"
                            pTooltip="Excluir" />
                    </div>
                </td>
            </tr>
        </ng-template>
        
        <ng-template #empty>
            <tr>
                <td colspan="8" class="text-center py-4">
                    Nenhum veículo encontrado.
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>